import {
  Box,
  Card,
  CardContent,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';

import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import { Gauge, gaugeClasses } from '@mui/x-charts';
import InfoTooltipIcon from '@/components/icons/InfoTooltipIcon';
import { formatNumber } from '@/utils/formatters';
import { useTranslation } from 'react-i18next';

const GoCard = ({ openGoShares, number, children }) => {
  const { t } = useTranslation('energyxplorer-esg');

  return (
    <Card
      variant="outlined"
      sx={{ p: 1, borderRadius: 2, minHeight: 240, height: '100%' }}
    >
      <CardContent>
        <Stack
          direction="column"
          color="inherit"
          component={Card}
          elevation={0}
          sx={{
            transition: 'box-shadow 0.3s ease',
            height: '100%',
            background: 'transparent',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  fontWeight="bold"
                >
                  {t('go_card.label')}
                </Typography>
                <InfoTooltipIcon title={t('go_card.description')} />
              </Box>
              <IconButton
                className="non-printable"
                size="small"
                onClick={() => openGoShares(true)}
                aria-label="slice-mode-selector"
                sx={{ borderRadius: 1 }}
              >
                <SettingsRoundedIcon />
              </IconButton>
            </Box>
          </Box>
          <div>
            {children && (
              <Box
                sx={{
                  mt: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {children}
              </Box>
            )}
            <Gauge
              width={200}
              height={130}
              value={number * 100}
              cornerRadius={'40%'}
              startAngle={-110}
              endAngle={110}
              text={`${formatNumber(number * 100)}%`}
              sx={(theme) => ({
                [`& .${gaugeClasses.valueText}`]: {
                  fontSize: 40,
                },
                [`& .${gaugeClasses.valueArc}`]: {
                  fill: '#52b202',
                  opacity: 0.8,
                },
                [`& .${gaugeClasses.referenceArc}`]: {
                  fill: theme.palette.text.disabled,
                  opacity: 0.5,
                },
                margin: '0 auto',
              })}
            />
          </div>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default GoCard;
